import React, { useMemo } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Box, Slider, Typography } from "@mui/material";

const COLORS = ["#90caf9", "#64b5f6", "#42a5f5", "#1e88e5"];

const LABELS = {
  none: "None",
  googleTravel: "Google Travel",
  googleShopping: "Google Shopping",
  youtube: "YouTube",
};

const keys = ["none", "googleTravel", "googleShopping", "youtube"];

const LogicDistributionPie = ({ value, onChange }) => {
  // Prepare pie data
  const pieData = useMemo(
    () =>
      keys.map((k) => ({
        name: LABELS[k],
        key: k,
        value: value[k],
      })),
    [value]
  );

  const handleSliderChange = (key, newVal) => {
    if (key === "none") return; // None is auto calculated

    const updated = { ...value, [key]: newVal };

    const sumWithoutNone =
      updated.googleTravel +
      updated.googleShopping +
      updated.youtube;

    // Prevent exceeding 100%
    if (sumWithoutNone > 100) {
      return;
    }

    // Auto adjust none
    updated.none = 100 - sumWithoutNone;

    onChange(updated);
  };

  return (
    <Box sx={{ width: "100%", display: "flex", gap: 4 }}>
      {/* PIE SECTION */}
      <Box sx={{ width: "40%", height: 260 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={pieData}
              dataKey="value"
              nameKey="name"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={2}
            >
              {pieData.map((entry, i) => (
                <Cell key={entry.key} fill={COLORS[i]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </Box>

      {/* SLIDERS SECTION */}
      <Box sx={{ width: "60%" }}>
        {keys.map((key) => (
          <Box key={key} sx={{ mb: 3 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: key === "none" ? 600 : 400,
                color: key === "none" ? "primary.main" : "inherit",
              }}
            >
              {LABELS[key]} — {value[key]}%
            </Typography>

            <Slider
              value={value[key]}
              min={0}
              max={100}
              disabled={key === "none"}
              onChange={(_, v) => handleSliderChange(key, v)}
            />
          </Box>
        ))}

        <Typography
          variant="caption"
          sx={{ opacity: 0.7 }}
        >
          Total: 100%
        </Typography>
      </Box>
    </Box>
  );
};

export default LogicDistributionPie;